import React from "react";
import { Dropdown } from "react-bootstrap";
import MyDropdownButton from "../Common/MyDropdownButton";
import SelectApiIcon from "../../assets/icons/Icon_Library/application icons/general/api_type.svg2";
import PingIcon from "../../assets/icons/monitoring/monitor_types/icon_alert.svg2";
import CreateApiIcon from "../../assets/icons/create_api_connection.svg2";
import SmsIcon from "../../assets/icons/messages-01.svg2";
import EmailIcon from "../../assets/icons/icon_email-01.svg2";
import VoiceIcon from "../../assets/icons/icon_voice_tel-01.svg2";
import ApiIcon from "../../assets/icons/api_connections.svg2";
import OtherIcon from "../../assets/icons/Icon_Library/application icons/general/self-manage.svg2";
import { icon } from "@fortawesome/fontawesome-svg-core";

export const howtoServiceOptions = [
  {
    name: "sms",
    heading: "SMS",
    icon: SmsIcon,
    info: (
      <div>
        <div className="fw-bold">About SMS</div>
        <div>
          Receive monitoring updates directly via text messages. Use SMS to
          report incidents, share status updates, or receive alerts—ensuring
          critical information is delivered instantly, even without internet
          access.
        </div>
      </div>
    ),
  },
  {
    name: "email",
    heading: "Email",
    icon: EmailIcon,
    info: (
      <div>
        <div className="fw-bold">About Email</div>
        <div>
          Connect to the monitoring service via email to send reports, receive
          alerts, and share updates directly from your inbox. Email integration
          ensures detailed communication and record-keeping for all monitoring
          activities.
        </div>
      </div>
    ),
  },
  {
    name: "httpsAPI",
    heading: "HTTPS / API",
    icon: ApiIcon,
    info: (
      <div>
        <div className="fw-bold">About HTTPS / API </div>
        <div>
          Connect to the service via secure HTTPS or API integration to send and
          receive monitoring data in real time. This method supports automated
          workflows and direct system-to-system communication.
        </div>
      </div>
    ),
  },
  {
    name: "voice",
    heading: "Voice",
    icon: VoiceIcon,
    info: (
      <div>
        <div className="fw-bold">About Voice</div>
        <div>
          Connect to the service via voice calls to deliver alerts, status
          updates, or critical information directly to designated recipients.
          Ideal for urgent notifications that require immediate attention.
        </div>
      </div>
    ),
  },
  {
    name: "Other",
    heading: "Other",
    icon: OtherIcon,
    info: (
      <div>
        <div className="fw-bold">Others...</div>
        <div>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia
          numquam ipsam, modi esse labore aperiam tempora, dicta eius ea
          quibusdam voluptatem harum, adipisci explicabo consequuntur ipsum
          doloremque eveniet magnam asperiores.
        </div>
      </div>
    ),
  },
];

export const howtoMonitorOptions = [
  {
    name: "ping",
    heading: "Ping",
    info: (
      <div>
        <div className="fw-bold">About Ping</div>
        <div>
          Boomerang makes an outbound request to an external resource (endpoint
          / port / device etc.) to verify access, availability, performance /
          latency etc
        </div>
      </div>
    ),
  },
  {
    name: "heartbeat",
    heading: "Heartbeat",
    info: (
      <div>
        <div className="fw-bold">About Heartbeat</div>
        <div>
          Requests are received at scheduled intervals from an external source
          and failure to receive a request when expected, is used as the trigger
          to activate a workflow
        </div>
      </div>
    ),
  },
  {
    name: "alert",
    heading: "Alert",
    info: (
      <div>
        <div className="fw-bold">About Alert</div>
        <div>
          Monitoring alerts are received from an external source (e.g.
          monitoring software) and used to trigger a workflow
        </div>
      </div>
    ),
  },
];
export const whatToPingOptions = [
  {
    name: "selectAnApi",
    heading: "Select an API",
    icon: SelectApiIcon,
    info: (
      <div>
        <div className="fw-bold">Select an API</div>
        <div className="text-secondary">
          Choose this option if you already have an API that exposes the data
          you want to monitor. Use this when your system, service, or
          third-party platform provides endpoints for health checks, metrics,
          logs, or status information. You’ll simply pick an existing API from
          your list and configure it.
        </div>
      </div>
    ),
  },
  {
    name: "createANewApi",
    heading: "Create a new API",
    icon: CreateApiIcon,
    info: (
      <div>
        <div className="fw-bold">Create a new API</div>
        <div className="text-secondary">
          Choose this option if no suitable API exists yet. This lets you define
          a new endpoint that your monitoring workflow will call. You’ll specify
          the request structure, response format, and any internal logic needed
          to gather metrics or status.
        </div>
      </div>
    ),
  },
];
export const typeOfMonitorOptions = [
  {
    name: "machineToMachine",
    heading: "Machine To Machine",
  },
  {
    name: "network",
    heading: "Network",
  },
  {
    name: "network2",
    heading: "Network 2",
  },
];
function HowToMonitor({ howtoMonitor, setHowtoMonitor }) {
  const selectedOption = howtoMonitorOptions.find(
    (o) => o.name === howtoMonitor?.name
  );
  return (
    <div className="">
      <div className="mb-3">
        <span className="fs-4 fw-bold ms-2">
          What method would you like to use for monitoring?
        </span>
      </div>
      <div className="mb-3">
        <Dropdown>
          <div className="d-flex">
            <Dropdown.Toggle
              id="dropdown-monitor-method"
              className="bg-white text-black w-100 border-0 d-flex justify-content-between align-items-center"
            >
              {selectedOption ? (
                <MyDropdownButton option={selectedOption} />
              ) : (
                <div className="fw-bold text-start fs-5">Please select...</div>
              )}
            </Dropdown.Toggle>
          </div>

          <Dropdown.Menu className="bg-purple-gradient">
            {howtoMonitorOptions.map((o) => (
              <Dropdown.Item href="#/action-1" className="border-bottom">
                <button
                  type="button"
                  className={`btn mb-2 rounded-4 w-100`}
                  onClick={(e) => {
                    e.preventDefault();
                    setHowtoMonitor({ ...howtoMonitor, name: o.name });
                  }}
                >
                  <div className="d-flex w-100">
                    <MyDropdownButton option={o} />
                  </div>{" "}
                </button>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {selectedOption && (
        <div className="bg-white rounded-3 p-3">{selectedOption?.info}</div>
      )}
    </div>
  );
}

export default HowToMonitor;
